<template>
    <section class="flex min-h-[600px] flex-col gap-4">
        <div
            v-if="!review"
            class="flex flex-1 flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 bg-white p-8 text-center text-gray-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400"
        >
            <p class="text-sm font-medium">
                Selecione um saque na lista para iniciar a análise.
            </p>
        </div>

        <template v-else>
            <div class="relative">
                <div
                    v-if="actionProcessing"
                    class="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/80 dark:bg-gray-800/80"
                >
                    <ticto-loading />
                </div>

                <div
                    :class="[
                        'space-y-4',
                        actionProcessing
                            ? 'pointer-events-none opacity-50'
                            : '',
                    ]"
                >
                    <div class="flex items-center justify-end gap-2">
                        <span
                            v-if="isSkipped"
                            class="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-600 dark:bg-slate-700 dark:text-slate-300"
                        >
                            Pulado
                        </span>
                        <button
                            type="button"
                            class="inline-flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                            v-tooltip="
                                'Manda este saque para o fim da fila sem decidir. Ele volta quando a fila esvaziar ou pelo botão Pulados'
                            "
                            @click="$emit('skip')"
                        >
                            Pular, decidir depois
                            <span aria-hidden="true">&rarr;</span>
                        </button>
                    </div>

                    <!-- Camada 1: o veredito de risco, antes de qualquer número -->
                    <chargeback-risk-badge
                        v-if="review.cashout"
                        :cashout-id="review.cashout.id"
                    />

                    <!-- Camada 2: valores do saque e a decisão -->
                    <review-cashout
                        :cashout="review.cashout"
                        :review="review"
                        :payable-details="payableDetails"
                        @fetch="$emit('refresh', review)"
                    />

                    <cashout-checklist
                        v-if="review.cashout"
                        ref="cashoutChecklist"
                        :cashout-id="review.cashout.id"
                        :processing="actionProcessing"
                    />

                    <!-- Camada 3: contexto do vendedor, para quando o veredito
                         e o checklist não bastam. Colapsado por padrão. -->
                    <div>
                        <button
                            type="button"
                            class="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.14em] text-gray-500 transition-colors hover:text-indigo-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 dark:text-gray-400 dark:hover:text-indigo-400"
                            :aria-expanded="contextOpen"
                            @click="contextOpen = !contextOpen"
                        >
                            <svg
                                class="h-3.5 w-3.5 transition-transform"
                                :class="{ 'rotate-90': contextOpen }"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M9 5l7 7-7 7"
                                ></path>
                            </svg>
                            Contexto do vendedor (Resumo 360°)
                        </button>

                        <review-summary-360
                            v-if="contextOpen"
                            class="mt-3"
                            :review="review"
                            :is-same-day-urgent="isSameDayUrgent"
                        />
                    </div>
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import ChargebackRiskBadge from "./ChargebackRiskBadge.vue";
import ReviewSummary360 from "./ReviewSummary360.vue";
import CashoutChecklist from "./CashoutChecklist.vue";
import ReviewCashout from "./ReviewCashout.vue";
import TictoLoading from "../../layouts/TictoLoading.vue";

export default {
    name: "ReviewDecisionPanel",
    components: {
        ChargebackRiskBadge,
        ReviewSummary360,
        CashoutChecklist,
        ReviewCashout,
        TictoLoading,
    },
    props: {
        review: {
            type: Object,
            default: null,
        },
        payableDetails: {
            type: Object,
            default: null,
        },
        isSameDayUrgent: {
            type: Boolean,
            default: false,
        },
        isSkipped: {
            type: Boolean,
            default: false,
        },
        actionProcessing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            contextOpen: false,
        };
    },
    watch: {
        "review.id"() {
            this.contextOpen = false;
        },
    },
    methods: {
        // Reload the cashout checklist
        async reloadCashoutChecklist() {
            if (
                this.$refs.cashoutChecklist &&
                this.$refs.cashoutChecklist.loadChecklist
            ) {
                return await this.$refs.cashoutChecklist.loadChecklist();
            }
        },
    },
};
</script>
